const topics = [
  { tag: '新番速递', icon: 'ri-rocket-line', desc: '本季最新上线的动画作品第一时间收录', color: 'bg-primary-100 text-primary-700' },
  { tag: '热血战斗', icon: 'ri-fire-line', desc: '燃到爆的战斗番，每一帧都是名场面', color: 'bg-accent-100 text-accent-700' },
  { tag: '恋爱甜宠', icon: 'ri-heart-line', desc: '甜甜的恋爱番剧，治愈你的每一天', color: 'bg-secondary-100 text-secondary-700' },
  { tag: '异世界冒险', icon: 'ri-earth-line', desc: '穿越异世界开启奇幻冒险之旅', color: 'bg-accent-100 text-accent-700' },
  { tag: '搞笑日常', icon: 'ri-emotion-laugh-line', desc: '轻松搞笑的日常番，笑到停不下来', color: 'bg-secondary-100 text-secondary-700' },
  { tag: '悬疑推理', icon: 'ri-search-eye-line', desc: '烧脑悬疑推理番，智商在线的选择', color: 'bg-primary-100 text-primary-700' },
  { tag: '治愈温情', icon: 'ri-plant-line', desc: '温暖治愈的番剧，抚慰疲惫的心灵', color: 'bg-secondary-100 text-secondary-700' },
  { tag: '经典重温', icon: 'ri-history-line', desc: '那些年追过的经典动漫，值得再看', color: 'bg-accent-100 text-accent-700' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            追更专题
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            按类型分类浏览你最爱的动漫番剧，找到属于你的追更节奏
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {topics.map((topic, i) => (
            <a
              key={i}
              href="#ranking"
              className="group bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className={`w-11 h-11 flex items-center justify-center rounded-lg ${topic.color} mb-4 group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${topic.icon} text-lg`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-2 font-heading">
                {topic.tag}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed">
                {topic.desc}
              </p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}